import React, { useState } from "react";
import PoliceVerification from "./PoliceVerificationNew";
import WebMediaSearch from "./WebMediaSearchVerification";
import "../styles/pageStyles.css";
import { useSelector, useDispatch } from "react-redux";
import Form26 from "./Form26AS";
import Form16 from "./Form16";
import DirectorshipVerification from "./DirectorshipVerification";
import CompanyCheckVerification from "./CompanyCheckVerification";
import VendorVerification from "./VendorVerification";
import OfficialNameChangeVerification from "./OfficialNameChangeVerification";
import FranchiseVerification from "./FranchiseVerification";
import BankStatementVerification from "./BankStatementVerificationNew";
import {
  createSubTable,
  deleteSubTable,
  editCellInExecutiveSummary,
} from "../store/pdfdata/pdfdataSliceNew";
import SummaryFormPieChart from "./SummaryFormPieChart";
import RightToWorkVerification from "./RightToWorkVerification";
import EditCellTitleModel from "./EditCellTitleModel";
import ColorCheckFun from "./ColorCheckFunNew";
import NationalPoliceAndHundredCheck from "./NationalPoliceAndHundredCheck";
import NotificationAlert from "./NotificationAlert";
import ConfirmationDialog from "./ConfirmationDialog";
import EducationNew from "./EducationNew";
import EmploymentNew from "./EmploymentNew";
import GapNew from "./GapNew";
import IdentityNew from "./IdentityNew";
import CriminalNew from "./CriminalVerificationNew";
import AddressVerificationNew from "./AddressVerificationNew";
import CourtCheckNew from "./CourtCheckNew";
import ProfessionalReferenceCheckNew from "./ProfessionalReferenceNew";
import UANNew from "./UANVerificationNew";
import DatabaseVerificationNew from "./DatabaseVerificationNew";
import CreditCheckNew from "./CreditCheckNew";
import DrugVerificationNew from "./DrugVerificationNew";

const ExecutiveSummaryNew = () => {
  const dispatch = useDispatch();

  const forms = useSelector((state) => state.pdfdatanew.forms);
  const executiveSummaryTypes = useSelector(
    (state) => state.pdfdatanew.executiveSummary
  );

  const [selectedPositionAddSubTable, setselectedPositionAddSubTable] =
    useState(0);
  const [selectedPositionAddSubCheck, setSelectedPositionAddSubCheck] =
    useState(0);
  const [selectedCellPosition, setSelectedCellPosition] = useState("");
  const [selectedPreviousCellTitle, setSelectedPreviousCellTitle] =
    useState("");
  const [selectedCellTitle, setSelectedCellTitle] = useState("");
  const [selectedSubtable, setSelectedSubtable] = useState("");
  const [confirmation, setConfirmation] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  const addSubtablesToState = (
    mainTable,
    subTable,
    selectedPositionAddSubTable
  ) => {
    dispatch(
      createSubTable([mainTable, subTable, selectedPositionAddSubTable])
    );
  };
  const deleteSubForm = (mainTable, subTable) => {
    setConfirmation({
      ...confirmation,
      isOpen: false,
    });
    dispatch(deleteSubTable([mainTable, subTable]));
    ColorCheckFun(dispatch, executiveSummaryTypes, subTable, "");
    setNotify({
      isOpen: true,
      message: "Sub check has been deleted!",
      type: "error",
    });
  };

  if (Object.keys(executiveSummaryTypes).length === 0) return null;

  let counter = -1;

  const formTypesSequence = [
    "Education Verification",
    "Employment Verification",
    "Gap Verification",
    "Professional Reference Check",
    "Address Verification",
    "Identity Verification",
    "Credit Check",
    "Drug Verification",
    "Criminal Verification",
    "Court Verification",
    "Police Verification",
    "Bank Statement Verification",
    "Database Verification",
  ];

  const handleMap = (key) => {
    counter++;
    return true;
  };

  return (
    <div>
      <NotificationAlert notify={notify} setNotify={setNotify} />
      <ConfirmationDialog
        confirmation={confirmation}
        setConfirmation={setConfirmation}
      />

      <SummaryFormPieChart data={executiveSummaryTypes} />
      <table>
        <colgroup>
          <col span="1" style={{ width: "33%" }} />
          <col span="1" style={{ width: "50%" }} />
          <col span="1" style={{ width: "17%" }} />
        </colgroup>
        <thead>
          <tr>
            <th className="heading centered-text" colSpan={3}>
              <h3 className="ES-heading">Executive Summary</h3>
            </th>
          </tr>
          <tr>
            <th className="centered-text" scope="col">
              Type of Check
            </th>
            <th className="centered-text" scope="col">
              Remarks
            </th>
            <th className="centered-text" scope="col">
              Status
            </th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(executiveSummaryTypes).map((table, index) => (
            <>
              <tr>
                {
                  <th colSpan={3} className="table-heading" id="headerName">
                    {table}{" "}
                    <div className="float-end">
                      <button
                        type="button"
                        className="btn btn-circle btn-sm btn-outline-dark"
                        data-bs-toggle="modal"
                        title="Add New Sub Check"
                        data-bs-target={"#exampleModal" + index}
                        data-bs-whatever="@mdo"
                        onClick={() => {
                          setSelectedSubtable(table);
                        }}
                      >
                        <b
                          style={{
                            color: "#32cd32",
                            fontWeight: "900",
                            fontSize: "18px",
                          }}
                        >
                          +
                        </b>
                      </button>
                    </div>
                    <div
                      className="modal fade"
                      id={"exampleModal" + index}
                      tabIndex="-1"
                      role="dialog"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                      data-bs-backdrop="static"
                      data-bs-keyboard="false"
                    >
                      <div
                        className="modal-dialog dialog-of-modal"
                        role="document"
                      >
                        <div className="modal-content content-modal">
                          <div className="modal-header">
                            <h5
                              className="modal-title title-modal"
                              id="exampleModalLabel"
                            >
                              Add new Subcheck for {table}
                            </h5>
                          </div>
                          <hr />

                          <div className="modal-body body-modal">
                            <div className="mb-2">
                              <label
                                htmlFor="sel1"
                                className="form-label float-start  Position"
                              >
                                * New Cell Will Be Added Just After The Selected
                                Cell (for adding at the top or for new check
                                select "Top").
                              </label>

                              <select
                                className="form-control border border-secondary"
                                name="subtable1"
                                id="sel1"
                                value={selectedPositionAddSubTable}
                                onChange={(e) => {
                                  setselectedPositionAddSubTable(
                                    e.target.value
                                  );
                                }}
                              >
                                <option value="0">Top</option>
                                {selectedSubtable !== "" ? (
                                  Object.keys(forms[selectedSubtable]).map(
                                    (key, index) => {
                                      return (
                                        <>
                                          <option value={index + 1}>
                                            {key}
                                          </option>
                                        </>
                                      );
                                    }
                                  )
                                ) : (
                                  <></>
                                )}
                              </select>

                              {table === "Drug Verification" ? (
                                <>
                                  <label className="form-label float-start">
                                    Select Drug Test
                                  </label>
                                  <select
                                    className="form-control border border-secondary"
                                    name="subtable"
                                    id={"subtableInput" + index}
                                    value={selectedPositionAddSubCheck}
                                    onChange={(e) =>
                                      setSelectedPositionAddSubCheck(
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option value="5 Panel Drug Test (Per Sample urine)">
                                      5 Panel Drug Test (Per Sample urine)
                                    </option>
                                    <option value="5 Panel Drug Test (Per Sample Hair)">
                                      5 Panel Drug Test (Per Sample Hair)
                                    </option>
                                    <option value="7 Panel Drug Test">
                                      7 Panel Drug Test{" "}
                                    </option>
                                    <option value="8 Panel Urine Drug Test">
                                      8 Panel Urine Drug Test
                                    </option>
                                    <option value="9 Panel Urine Drug Test">
                                      9 Panel Urine Drug Test
                                    </option>
                                    <option value="10 Panel Drug Test">
                                      10 Panel Drug Test{" "}
                                    </option>
                                    <option value="11 Panel Drug Test">
                                      11 Panel Drug Test{" "}
                                    </option>
                                    <option value="12 Panel Drug Test">
                                      12 Panel Drug Test{" "}
                                    </option>
                                  </select>
                                </>
                              ) : table === "Gap Verification" ? (
                                <>
                                  <label className="form-label float-start">
                                    Select Gap Verification Type
                                  </label>
                                  <select
                                    className="form-control border border-secondary"
                                    name="subtable"
                                    id={"subtableInput" + index}
                                    value={selectedPositionAddSubCheck}
                                    onChange={(e) =>
                                      setSelectedPositionAddSubCheck(
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option value="Education to Education">
                                      Education to Education
                                    </option>
                                    <option value="Education to Employment">
                                      Education to Employment
                                    </option>
                                    <option value="Employment to Employment">
                                      Employment to Employment
                                    </option>
                                  </select>
                                </>
                              ) : table === "Court Verification" ? (
                                <>
                                  <label className="form-label float-start SubCheck">
                                    Select Court Verification Type
                                  </label>

                                  <select
                                    className="form-control border border-secondary"
                                    name="subtable2"
                                    id={"subtableInput" + index}
                                    value={selectedPositionAddSubCheck}
                                    onChange={(e) => {
                                      setSelectedPositionAddSubCheck(
                                        e.target.value
                                      );
                                    }}
                                  >
                                    <option value="Court Proceedings">
                                      Court Proceedings
                                    </option>
                                    <option value="Criminal Proceedings">
                                      Criminal Proceedings
                                    </option>
                                  </select>
                                </>
                              ) : table === "Identity Verification" ? (
                                <>
                                  <label className="form-label float-start">
                                    Select Identity Verification Type
                                  </label>
                                  <select
                                    className="form-control border border-secondary"
                                    name="subtable"
                                    id={"subtableInput" + index}
                                    value={selectedPositionAddSubCheck}
                                    onChange={(e) =>
                                      setSelectedPositionAddSubCheck(
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option value="Driving Licence">
                                      Driving Licence
                                    </option>
                                    <option value="Permanent Account Number (PAN) Verification">
                                      Permanent Account Number (PAN)
                                      Verification
                                    </option>
                                    <option value="Aadhaar Card Verification">
                                      Aadhaar Card Verification
                                    </option>
                                    <option value="Passport Investigation">
                                      Passport Investigation
                                    </option>
                                  </select>
                                </>
                              ) : (
                                <>
                                  <label className="form-label float-start">
                                    Subcheck Name:
                                  </label>
                                  <input
                                    id={"subtableInput" + index}
                                    type="text"
                                    className="form-control-sm border border-secondary"
                                  />
                                </>
                              )}
                            </div>
                          </div>

                          <hr />

                          <div className="modal-footer justify-content-around">
                            <button
                              type="button"
                              title="Save New Subchek"
                              onClick={(e) => {
                                e.preventDefault();
                                const subtable = document.getElementById(
                                  "subtableInput" + index
                                ).value;
                                if (subtable !== "") {
                                  if (
                                    executiveSummaryTypes[table][subtable] ===
                                    undefined
                                  ) {
                                    addSubtablesToState(
                                      table,
                                      subtable,
                                      selectedPositionAddSubTable
                                    );
                                  } else
                                    setNotify({
                                      isOpen: true,
                                      message: `Subcheck named ${subtable} already exists!`,
                                      type: "warning",
                                    });
                                } else {
                                  setNotify({
                                    isOpen: true,
                                    message: "Subcheck is empty!",
                                    type: "warning",
                                  });
                                }
                                setselectedPositionAddSubTable(0);
                                setSelectedSubtable("");
                                document.getElementById(
                                  "subtableInput" + index
                                ).value = "";
                              }}
                              className="btn-modal button-close button-close-hover"
                              data-bs-dismiss="modal"
                            >
                              Save
                            </button>
                            <button
                              type="button"
                              title="Close This Modal"
                              className="btn-modal button-close button-close-hover"
                              data-bs-dismiss="modal"
                              onClick={(e) => {
                                e.preventDefault();
                                setselectedPositionAddSubTable(0);
                                setSelectedSubtable("");
                                document.getElementById(
                                  "subtableInput" + index
                                ).value = "";
                              }}
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </th>
                }
              </tr>

              {Object.keys(executiveSummaryTypes[table]).map((row, index) => (
                <tr>
                  <td
                    className="cellTitle"
                    style={{ width: "25%", wordBreak: "break-all" }}
                  >
                    <div className="row">
                      <div className="col-10">{row}</div>
                      <div className="col-1">
                        <button
                          className="editIcon fa fa-pencil"
                          type="button"
                          data-bs-toggle="modal"
                          title="Edit Cell Title"
                          data-bs-target={`#Edit${index}`}
                          data-bs-whatever="@mdo"
                          onClick={() => {
                            setSelectedCellPosition(index);
                            setSelectedPreviousCellTitle(row);
                            setSelectedCellTitle(row);
                            setSelectedSubtable(table);
                          }}
                        ></button>
                      </div>
                      <div className="col-1">
                        <button
                          className="editIcon fa fa-trash"
                          type="button"
                          title="Delete Cell Title"
                          onClick={(e) => {
                            setConfirmation({
                              isOpen: true,
                              title: "Are you sure to delete this cell?",
                              subTitle: "You can't undo this operation!",
                              onConfirm: () => {
                                deleteSubForm(table, row);
                              },
                            });
                          }}
                        ></button>
                      </div>
                    </div>
                  </td>
                  {table === "Form16 Verification" ||
                  table === "Form26-AS Verification" ? (
                    <td colSpan={2}>
                      {executiveSummaryTypes[table][row].remarks}
                    </td>
                  ) : (
                    <>
                      <td>{executiveSummaryTypes[table][row].remarks}</td>
                      <td className={executiveSummaryTypes[table][row].status}>
                        {executiveSummaryTypes[table][row].status}
                      </td>
                    </>
                  )}
                  <EditCellTitleModel
                    modelId={`Edit${index}`}
                    onEditCell={() => {
                      if (
                        executiveSummaryTypes[selectedSubtable][
                          selectedCellTitle
                        ] === undefined
                      ) {
                        dispatch(
                          editCellInExecutiveSummary({
                            selectedPreviousCellTitle,
                            selectedSubtable,
                            selectedCellTitle,
                            selectedCellPosition,
                          })
                        );
                      } else
                        setNotify({
                          isOpen: true,
                          message: `Subcheck named ${selectedCellTitle} already exists!`,
                          type: "warning",
                        });
                    }}
                    currentTitle={selectedCellTitle}
                    setCurrentTitle={setSelectedCellTitle}
                  />
                </tr>
              ))}
            </>
          ))}
        </tbody>
      </table>

      {formTypesSequence.map((key, index) =>
        forms && forms[key] && Object.keys(forms[key]).length >= 1 ? (
          handleMap(key) &&
          (key === "Education Verification" ? (
            <EducationNew annexure={String.fromCharCode(counter + 65)} />
          ) : key === "Employment Verification" ? (
            <EmploymentNew annexure={String.fromCharCode(counter + 65)} />
          ) : key === "Gap Verification" ? (
            <GapNew annexure={String.fromCharCode(counter + 65)} />
          ) : key === "Identity Verification" ? (
            <IdentityNew annexure={String.fromCharCode(counter + 65)} />
          ) : key === "Criminal Verification" ? (
            <CriminalNew annexure={String.fromCharCode(counter + 65)} />
          ) : key === "Database Verification" ? (
            <DatabaseVerificationNew
              annexure={String.fromCharCode(counter + 65)}
            />
          ) : key === "Police Verification" ? (
            <PoliceVerification annexure={String.fromCharCode(counter + 65)} />
          ) : key === "Web and Media Search" ? (
            <WebMediaSearch annexure={String.fromCharCode(counter + 65)} />
          ) : key === "Drug Verification" ? (
            <DrugVerificationNew annexure={String.fromCharCode(counter + 65)} />
          ) : key === "Address Verification" ? (
            <AddressVerificationNew
              annexure={String.fromCharCode(counter + 65)}
            />
          ) : key === "UAN Verification" ? (
            <UANNew annexure={String.fromCharCode(counter + 65)} />
          ) : key === "Form26-AS Verification" ? (
            <Form26 annexure={String.fromCharCode(counter + 65)} />
          ) : key === "Form16 Verification" ? (
            <Form16 annexure={String.fromCharCode(counter + 65)} />
          ) : key === "Professional Reference Check" ? (
            <ProfessionalReferenceCheckNew
              annexure={String.fromCharCode(counter + 65)}
            />
          ) : key === "National Police Check & 100 Points Check" ? (
            <NationalPoliceAndHundredCheck
              annexure={String.fromCharCode(counter + 65)}
            />
          ) : key === "Credit Check" ? (
            <CreditCheckNew annexure={String.fromCharCode(counter + 65)} />
          ) : key === "Company Check Verification" ? (
            <CompanyCheckVerification
              annexure={String.fromCharCode(counter + 65)}
            />
          ) : key === "Vendor Verification" ? (
            <VendorVerification annexure={String.fromCharCode(counter + 65)} />
          ) : key === "Bank Statement Verification" ? (
            <BankStatementVerification
              annexure={String.fromCharCode(counter + 65)}
            />
          ) : key === "Official Name Change Verification" ? (
            <OfficialNameChangeVerification
              annexure={String.fromCharCode(counter + 65)}
            />
          ) : key === "Franchise Verification" ? (
            <FranchiseVerification
              annexure={String.fromCharCode(counter + 65)}
            />
          ) : key === "Directorship Verification" ? (
            <DirectorshipVerification
              annexure={String.fromCharCode(counter + 65)}
            />
          ) : key === "Court Verification" ? (
            <CourtCheckNew annexure={String.fromCharCode(counter + 65)} />
          ) : key === "Right To Work Verification" ? (
            <RightToWorkVerification
              annexure={String.fromCharCode(counter + 65)}
            />
          ) : (
            <></>
          ))
        ) : (
          <></>
        )
      )}
      <br />
      <br />
    </div>
  );
};
export default ExecutiveSummaryNew;
